import { render, staticRenderFns } from "./TwoFactorForm.vue?vue&type=template&id=f1f7c5c8&scoped=true"
import script from "./TwoFactorForm.vue?vue&type=script&lang=js"
export * from "./TwoFactorForm.vue?vue&type=script&lang=js"
import style0 from "./TwoFactorForm.vue?vue&type=style&index=0&id=f1f7c5c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1f7c5c8",
  null
  
)

export default component.exports